import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Stack.module.scss";
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
/**
 * Linear flex layout primitive. Defaults to a column; pass `direction="row"`
 * for a horizontal row. Use `Row` for the explicit row alias.
 */
export const Stack = ({ direction = "col", gap, align, justify, wrap = false, as: Tag = "div", className, children, ...rest }) => {
    return React.createElement(Tag, {
        className: cn(styles.stack, styles[`dir${cap(direction)}`], gap && styles[`gap${gap}`], align && styles[`align${cap(align)}`], justify && styles[`justify${cap(justify)}`], wrap && styles.wrap, className),
        ...rest,
    }, children);
};
export const Row = (props) => (_jsx(Stack, { ...props, direction: "row" }));
